import {getYMCID} from "./metrik.js";
import {DOMAIN} from "@/http";
import {modifyQuiz} from "@/page/quiz/scriptQuiz";

export function copyObj<T extends object>(obj: T): T {
  // Сохранение T при JSON-копировании — допущение для JSON-данных.
  // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
  return JSON.parse(JSON.stringify(obj)) as T;
}

export function getStyle(el: HTMLElement, styleProp: string): string {
  return getComputedStyle(el).getPropertyValue(styleProp);
}

export function getMonth(id: string): string {
  const monthList: {[key: string]: string} = {
    "01": "Январь",
    "02": "Февраль",
    "03": "Март",
    "04": "Апрель",
    "05": "Май",
    "06": "Июнь",
    "07": "Июль",
    "08": "Август",
    "09": "Сентябрь",
    10: "Октябрь",
    11: "Ноябрь",
    12: "Декабрь",

    Январь: "01",
    Февраль: "02",
    Март: "03",
    Апрель: "04",
    Май: "05",
    Июнь: "06",
    Июль: "07",
    Август: "08",
    Сентябрь: "09",
    Октябрь: "10",
    Ноябрь: "11",
    Декабрь: "12"
  };
  return monthList[id];
}
export function declensionMounth(mounth: string): string {
  const monthList: {[key: string]: string} = {
    Январь: "января",
    Февраль: "февраля",
    Март: "марта",
    Апрель: "aпреля",
    Май: "мая",
    Июнь: "июня",
    Июль: "июля",
    Август: "aвгуста",
    Сентябрь: "cентября",
    Октябрь: "октября",
    Ноябрь: "ноября",
    Декабрь: "декабря"
  };
  return monthList[mounth];
}

export function declensionMounthById(id: string): string {
  return declensionMounth(getMonth(id));
}

export function getUtm(): string {
  const search = location.search.substring(1);
  const ym_uid = getYMCID();
  if (search !== "" || ym_uid) {
    let newParams = "";

    if (search !== "") {
      try {
        // Keep the existing error for malformed percent encoding.
        decodeURI(search);
        const params = new Map<string, string>();
        new URLSearchParams(search).forEach((value, key) =>
          params.set(key, value)
        );
        params.forEach((value, key) => {
          if (key.substring(0, 3).toLowerCase() === "utm") {
            newParams += `${key}: ${value}\n`;
          }
        });
      } catch (e) {
        throw new Error("Ошибка парсинга UTM-строки: " + JSON.stringify(e));
      }
    }

    if (ym_uid) {
      newParams += ym_uid.replace("=", ": ") + "\n";
    }

    return newParams;
  }

  return "";
}

export async function printPhoto(element: HTMLElement): Promise<void> {
  const path = element.getAttribute("data-img");
  if (!path) {
    return;
  }
  let position: unknown;
  let rightSectionNumber;
  let elementNumber;

  if (path.includes("photoRightSection")) {
    const bloks = path.split("/");
    const last = bloks[bloks.length - 1];
    const numbers = last.split("-")[0];
    const numbersSplit = numbers.split(numbers.includes("_") ? "_" : "-");
    rightSectionNumber = numbersSplit[0];
    elementNumber = numbersSplit[1];
  }
  if (rightSectionNumber && elementNumber) {
    position = modifyQuiz("get", "", [
      "rightSectionList",
      rightSectionNumber,
      "positioningImg",
      elementNumber
    ]);
  }

  if (!path) return;
  const baseUrl = `https://${DOMAIN}/api/img?name=${path}`;

  const lowUrl = `${baseUrl}&low=1`;
  element.style.backgroundImage = `url(${lowUrl})`;

  if (typeof position === "string" && position) {
    element.style.backgroundPosition = position;
  }

  element.style.filter = "blur(20px)";
  element.style.transition = "filter 0.4s ease";
  const fullUrl = `${baseUrl}`;
  const img = new Image();
  img.src = fullUrl;
  await img.decode().catch(() => {});
  const parent = element.parentElement;
  if (parent) {
    const parentClass = parent.classList.value;

    if (parentClass.includes("information")) {
      element.style.aspectRatio = `${img.width} / ${img.height}`;
    }
  }
  element.style.backgroundImage = `url(${fullUrl})`;

  requestAnimationFrame(() => {
    element.classList.add("photo-loaded");
    element.style.filter = "blur(0)";
  });
}

export function autoInitPhotoLoader(): void {
  const process = (el: Element): void => {
    if (el instanceof HTMLElement && el.hasAttribute("data-img")) {
      void printPhoto(el);
    }
  };

  document.querySelectorAll("[data-img]").forEach(process);

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      mutation.addedNodes.forEach((node) => {
        if (!(node instanceof HTMLElement)) return;

        if (node.hasAttribute("data-img")) {
          process(node);
        }

        node.querySelectorAll?.("[data-img]").forEach((el) => process(el));
      });
    }
  });

  observer.observe(document.body, {childList: true, subtree: true});
}
